import { Component, forwardRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { AbstractControl, FormArray, FormControl, FormGroup, NG_VALUE_ACCESSOR } from "@angular/forms";

import { BaseFormControlComponent } from "../../../shared-library/form-controls/base-form-control.component";
import { DisposeMixin } from "../../../shared-library/mixins/dispose.mixin";

import { AggregationGroupModel } from "../../models/aggregation-group.model";
import { AggregationItemModel } from "../../models/aggregation-item.model";

@Component({
    selector: "pcg-ng-multiple-choice-facet",
    template: require('./multiple-choice-facet.component.html'),
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => MultipleChoiceFacetComponent), multi: true }
    ]
})
export class MultipleChoiceFacetComponent extends DisposeMixin(class extends BaseFormControlComponent<Array<string>> {
}) implements OnInit, OnChanges, OnDestroy {
    @Input()
    public aggregation: AggregationGroupModel;

    @Input()
    public allowMultipleChoice: boolean = true;

    public checkboxesList: FormArray = new FormArray([]);

    public constructor() {
        super();
    }

    public ngOnInit(): void {
    }

    public ngOnChanges(changes: SimpleChanges): void {
        this.buildCheckboxesList(changes.aggregation.currentValue);
    }

    public writeValue(value: any): void {
        super.writeValue(value);
        this.setSelectedCheckboxes();
    }

    public castToFormControl(control: AbstractControl): FormControl {
        return control as FormControl;
    }

    public castToFormGroup(control: AbstractControl): FormGroup {
        return control as FormGroup;
    }

    public getCheckboxTitle(value: string): string {
        const aggItem = this.aggregation.items.find(item => item.value === value);
        const title = aggItem ? `${aggItem.title} (${aggItem.count})` : "";

        return title;
    }

    private buildCheckboxesList(aggregation: AggregationGroupModel): void {
        this.checkboxesList.clear();

        aggregation.items.forEach(item => {
                const checkboxControl = new FormGroup({
                    isSelected: new FormControl(false),
                    key: new FormControl(item.value)
                });

                // TODO-VTA: store subscriptions in array and dispose it
                checkboxControl.valueChanges.subscribe((value: { isSelected: boolean, key: string }) => {
                    const newValue = this.value.slice();
                    if (value.isSelected) {
                        newValue.push(value.key);
                    } else {
                        newValue.splice(newValue.indexOf(value.key), 1);
                    }
                    this.writeNewValue(newValue);
                });

                this.checkboxesList.push(checkboxControl);
            }
        );

        this.setSelectedCheckboxes();
    }

    private setSelectedCheckboxes(): void {
        if (this.value && this.value.length) {
            for (const checkbox of this.checkboxesList.controls.map(c => c as FormGroup)) {
                const isSelected = this.value.indexOf(checkbox.controls.key.value) > -1;
                checkbox.controls.isSelected.setValue(isSelected, { emitEvent: false });
            }
        }
    }

    public ngOnDestroy(): void {
        this.dispose();
    }

    public onCategoriesGroupItemClicked(aggregation: { expanded: boolean } ): void {
        aggregation.expanded = !aggregation.expanded;
    }

    public onCategoryItemClicked(e: Event): void {
        const categoryId = (e.target as any).value;
        let selectedCategories = this.value || [];
        const categoryIndex = selectedCategories.findIndex(id => (id === categoryId));

        if (this.allowMultipleChoice) {
            if (categoryIndex > -1) {
                selectedCategories.splice(categoryIndex, 1);
            } else {
                selectedCategories.push(categoryId);
            }
        } else {
            selectedCategories = [];

            if (categoryIndex === -1) {
                selectedCategories.push(categoryId);
            }
        }

        this.aggregation.items.forEach(category => {
            category.selected = (selectedCategories.indexOf(category.value) > -1);

            if (category.subcategories) {
                category.subcategories.forEach(subcategory => {
                    subcategory.selected = (selectedCategories.indexOf(subcategory.value) > -1);
                });
            }
        });

        this.writeNewValue(selectedCategories);
    }
}
